export default "__VITE_ASSET__88e147c1__"